import { DeereFetch } from '../../../shared/fetch';

export default async function GetSignNowURL(envelopeId, signer) {
    const body = {
        envelopeID: envelopeId,
        signerName: signer.signerName,
        signerEmail: signer.signerEmail,
        routingOrder: signer.signingOrder,
        clientUserId: null
    }
    try {
        const signNowURL = await DeereFetch('/api/esign/sign-now', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(body)
        });
        const a = document.createElement('a');
        a.target = '_blank';
        a.rel = 'noopener';
        a.href = signNowURL.url;
        a.click();
    } catch (err) {
        /* eslint-disable no-console */
        console.log('Error fetching sign-now url:', err);
    }
}
